var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useParams } from "react-router-dom";
import Studio from "@/pages/moduleBuilder/studio";
import Menu from "./menu";
import { useTranslation } from "react-i18next";
export default function ModuleBuilder() {
    var type = useParams().type;
    var t = useTranslation(["common", "ModuleBuilder"]).t;
    var content = null;
    switch (type) {
        case "studio":
            content = _jsx(Studio, {});
            break;
        case "mb":
            content = _jsx(Studio, {});
            break;
        case "dropdown":
            content = _jsx(Studio, { tab: "list" });
            break;
        case undefined:
            content = (_jsxs("div", __assign({ className: "configurator bg-[var(--colors-bg-default)] text-[--colors-label] p-2 space-y-6 m-2 rounded-md" }, { children: [_jsx("div", __assign({ className: "" }, { children: _jsx(Menu, {}) })), _jsxs("div", __assign({ className: "py-2" }, { children: [_jsx("span", __assign({ className: "text-sm text-gray-500" }, { children: t("LBL_QUESTION_EDITOR", { ns: "ModuleBuilder" }) })), _jsxs("div", __assign({ className: "grid grid-cols-3 gap-4" }, { children: [_jsx("div", __assign({ className: "col-span-1" }, { children: _jsx("p", __assign({ className: "bg-teal-400  text-white py-2 px-4" }, { children: _jsx(Link, __assign({ to: "/modules/ModuleBuilder/studio" }, { children: t("LBL_STUDIO", { ns: "ModuleBuilder" }) })) })) })), _jsx("div", __assign({ className: "col-span-1" }, { children: _jsx("p", __assign({ className: "bg-teal-400  text-white py-2 px-4" }, { children: _jsx(Link, __assign({ to: "/modules/ModuleBuilder/mb" }, { children: t("LBL_MODULEBUILDER", { ns: "ModuleBuilder" }) })) })) })), _jsx("div", __assign({ className: "col-span-1" }, { children: _jsx("p", __assign({ className: "bg-teal-400  text-white py-2 px-4" }, { children: _jsx(Link, __assign({ to: "/modules/ModuleBuilder/dropdown" }, { children: t("LBL_DROPDOWNEDITOR", { ns: "ModuleBuilder" }) })) })) }))] }))] }))] })));
            break;
        default:
            content = _jsx("div", { children: "Unknown type" });
            break;
    }
    return (_jsx("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page" }, { children: content })));
}
